import { gql } from '@apollo/client';
// local imports
import { API_ADMIN_REPORT } from '../config/api';

export const ADMIN_TARGET_SKILLS_BY_EMPLOYEE_QUERY = gql`
  query ARTargetSkillsByEmployee(
    $report_id: Int!
    $offset: Int
    $limit: Int
  ) {
    arTargetSkillsByEmployee(
      report_id: $report_id,
      offset: $offset,
      limit: $limit
    )
    @rest(
      type: "ARTargetSkillsByEmployeePayload",
      path: "${API_ADMIN_REPORT}?limit={args.limit}&offset={args.offset}"
    ) {
      count
      results {
        id
        code
        email
        first_name
        last_name
        is_contractor
        count
      }
    }
  }
`;
